import { executeDelete } from "@/services/lukita";

const deleteProject = (slug) => executeDelete(`/projects/${slug}`);

export default function deleteProjects(slugs) {
  return Promise.all(slugs.map(deleteProject));
}
